import { _ as _tagged_template_literal } from "@swc/helpers/_/_tagged_template_literal";
function _templateObject() {
    const data = _tagged_template_literal([
        "\n  li {\n    width: 100%;\n  }\n"
    ]);
    _templateObject = function() {
        return data;
    };
    return data;
}
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { ButtonWithDropdownMenu } from "@/components/Categories/Menu";
import { CustomMenuButton } from "@/components/Categories/Menu/DetailFilterButton";
import { stepCodeLookup } from "@/components/edition/category/components/content/ProductListItem";
import { FilterTitle } from "@/components/Search/index";
import { SearchRecommendFilterWrap } from "@/components/Search/SearchRecommendFilter";
import { mixpanelEvent } from "@/lib/mixpanels/mixpanel";
import { cn } from "@/lib/utils";
import useWindowDimensions from "@/lib/web-ui/useWindowDimensions";
import { SOLVOOKPASS_TEXT } from "@/settings/constant";
import { Tooltip } from "@bookips/sds";
import { styled } from "@mui/material";
import React, { useMemo } from "react";
import { BaseFilterKeyToLabel, SearchQueryKey } from "../../api/search";
// 필터 표시 순서: 교재, 단원, 학습단계, 자료유형, 제작자, 이용권
const filterOrder = [
    SearchQueryKey.RELATEDBOOKS,
    SearchQueryKey.UNITS,
    SearchQueryKey.STEPS,
    SearchQueryKey.DATATYPES,
    SearchQueryKey.AUTHORS,
    SearchQueryKey.TICKETS
];
export const SearchDetailFilter = (param)=>{
    let { handleSolvookPassesFilter , onClickFilter , filterList , isCheckFilterItem , isCheckFilterCount , handleMobileSlider , hasSolvookPassesFilter , hasFilterItems , isSolvookPassClicked  } = param;
    var _filterList_SearchQueryKey_SOLVOOKPASSES;
    const { isMobile  } = useWindowDimensions();
    if (!filterList) return;
    const solvookPassesName = (_filterList_SearchQueryKey_SOLVOOKPASSES = filterList[SearchQueryKey.SOLVOOKPASSES]) === null || _filterList_SearchQueryKey_SOLVOOKPASSES === void 0 ? void 0 : _filterList_SearchQueryKey_SOLVOOKPASSES[0];
    const filteringSolvookPasses = useMemo(()=>{
        if (!filterList) return;
        return Object.keys(filterList).filter((filter)=>filter !== SearchQueryKey.SOLVOOKPASSES).sort((a, b)=>{
            const indexA = filterOrder.indexOf(a);
            const indexB = filterOrder.indexOf(b);
            // filterOrder에 없는 항목은 맨 뒤로
            if (indexA === -1) return 1;
            if (indexB === -1) return -1;
            return indexA - indexB;
        });
    }, [
        filterList
    ]);
    if (!hasFilterItems) return /*#__PURE__*/ _jsx(SearchDetailFilterSkeleton, {});
    return /*#__PURE__*/ _jsxs(SearchRecommendFilterWrap, {
        children: [
            /*#__PURE__*/ _jsx(FilterTitle, {
                children: "상세 필터"
            }),
            /*#__PURE__*/ _jsx("div", {
                className: "filter-list",
                children: /*#__PURE__*/ _jsxs("div", {
                    className: "stack",
                    children: [
                        hasSolvookPassesFilter && /*#__PURE__*/ _jsx(Tooltip, {
                            description: "지금 무료 다운!",
                            variant: "accent",
                            side: "top",
                            sideOffset: -7,
                            showArrow: true,
                            open: !isMobile,
                            children: /*#__PURE__*/ _jsx(ButtonWithDropdownMenu, {
                                className: isSolvookPassClicked ? "selected" : "",
                                onClick: (e)=>{
                                    e.preventDefault();
                                    handleSolvookPassesFilter(solvookPassesName);
                                    mixpanelEvent("Search Filtered", {
                                        "Filter Type": "쏠북패스",
                                        "Filter Option Selected": "쏠북패스"
                                    });
                                },
                                children: SOLVOOKPASS_TEXT
                            })
                        }),
                        filteringSolvookPasses.map((filter, idx)=>{
                            const filterName = BaseFilterKeyToLabel[filter];
                            if (filterList[filter].length > 0) return /*#__PURE__*/ _jsx(CustomMenuButton, {
                                filterName: filterName,
                                items: filterList[filter],
                                mobileFilterOpen: ()=>handleMobileSlider(true, filter),
                                isCheckFilterItem: isCheckFilterItem,
                                isCheckFilterCount: isCheckFilterCount,
                                children: /*#__PURE__*/ _jsx(CustomMenuButton.MenuItemListLayout, {
                                    children: filterList[filter].map((item, idx)=>{
                                        if (!item && item !== 0) return;
                                        if (filter === SearchQueryKey.TICKETS && typeof item === "object") {
                                            return /*#__PURE__*/ _jsx(SearchLastDropdownStyle, {
                                                style: {
                                                    width: "100%"
                                                },
                                                children: /*#__PURE__*/ _jsx(CustomMenuButton.MenuItem, {
                                                    checked: isCheckFilterItem(filter, String(item.id)),
                                                    onChange: ()=>{
                                                        onClickFilter(filter, String(item.id));
                                                        //mx-47
                                                        mixpanelEvent("Search Filtered", {
                                                            "Filter Type": filterName,
                                                            "Filter Option Selected": item.value
                                                        });
                                                    },
                                                    children: item.value
                                                })
                                            }, filterName + idx + item.id);
                                        }
                                        if (filter === SearchQueryKey.STEPS && typeof item === "number") {
                                            const stepLabel = stepCodeLookup[item] || String(item);
                                            return /*#__PURE__*/ _jsx(CustomMenuButton.MenuItem, {
                                                checked: isCheckFilterItem(filter, String(item)),
                                                onChange: ()=>{
                                                    onClickFilter(filter, String(item));
                                                    mixpanelEvent("Search Filtered", {
                                                        "Filter Type": filterName,
                                                        "Filter Option Selected": stepLabel
                                                    });
                                                },
                                                children: stepLabel
                                            }, filterName + idx + item);
                                        }
                                        if (typeof item === "string") {
                                            return /*#__PURE__*/ _jsx(CustomMenuButton.MenuItem, {
                                                checked: isCheckFilterItem(filter, item),
                                                onChange: ()=>{
                                                    onClickFilter(filter, item);
                                                    //mx-47
                                                    mixpanelEvent("Search Filtered", {
                                                        "Filter Type": filterName,
                                                        "Filter Option Selected": item
                                                    });
                                                },
                                                children: item
                                            }, filterName + idx + item);
                                        }
                                    })
                                })
                            }, idx);
                        })
                    ]
                })
            })
        ]
    });
};
const SearchDetailFilterSkeleton = (param)=>{
    let { className  } = param;
    return /*#__PURE__*/ _jsx("div", {
        className: cn("h-[52px] w-full animate-pulse rounded-md bg-gray-200", className)
    });
};
const SearchLastDropdownStyle = styled("div")(_templateObject());
